import { render } from "./SomethingWrongOverlay.vue?vue&type=template&id=5d564598&ts=true"
import script from "./SomethingWrongOverlay.vue?vue&type=script&lang=ts"
export * from "./SomethingWrongOverlay.vue?vue&type=script&lang=ts"

import "./SomethingWrongOverlay.vue?vue&type=style&index=0&id=5d564598&lang=scss"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__